import { Injectable } from '@angular/core';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { UserGroupCategories } from '@sb-tools/typescript/models/user-group-categories.model';
import { SimpleCommunityWithOpenTicketsCount } from '@core/models/simple-community-with-open-tickets-count.model';
import { MaxInstallationCounts } from '@community-settings/core/models/max-installation-counts.model';
import { CommunityUserWithAccessibleElements } from '@core/models/community-user-with-accessible-elements.model';
import { DetailedTag } from '@community-settings/core/models/detailed-tag.model';
import { Field } from '@sb-tools/typescript/models/field.model';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { Category } from '@sb-tools/typescript/models/category.model';
import { CustomerSettings } from '@sb-tools/typescript/models/customer-settings.model';
import { GdprPortalModel } from '@sb-tools/typescript/models/dto/gdpr-portal-model.model';

export const ReplaySubjectCount = 1;

@Injectable({
    providedIn: 'root',
})
export class CommonDataForSettingsService {
    allUsers: BaseUserWithRole[];
    categories: Category[];
    communities: SimpleCommunityWithOpenTicketsCount[];
    communityName: string;
    communityUser: CommunityUser | CommunityUserWithAccessibleElements;
    currentField: Field;
    currentTeammateGroup: BehaviorSubject<UserGroupCategories> = new BehaviorSubject<UserGroupCategories>(null);
    currentTeammateGroup$: Observable<UserGroupCategories> = this.currentTeammateGroup.asObservable();
    currentTeammateUser: BehaviorSubject<CommunityUserWithAccessibleElements> =
        new BehaviorSubject<CommunityUserWithAccessibleElements>(null);
    currentTeammateUser$: Observable<CommunityUserWithAccessibleElements> = this.currentTeammateUser.asObservable();
    currentPortal: BehaviorSubject<GdprPortalModel> = new BehaviorSubject<GdprPortalModel>(null);
    currentPortal$: Observable<GdprPortalModel> = this.currentPortal.asObservable();
    customerSettings: ReplaySubject<CustomerSettings> = new ReplaySubject<CustomerSettings>(ReplaySubjectCount);
    customerSettings$: Observable<CustomerSettings> = this.customerSettings.asObservable();
    language: 'nb' | 'en' | 'sv_SE' | 'da';
    socialMediaLimits: MaxInstallationCounts;
    tags: DetailedTag[];
    user: ReplaySubject<CommunityUserWithAccessibleElements> = new ReplaySubject<CommunityUserWithAccessibleElements>(
        ReplaySubjectCount,
    );
    user$: Observable<CommunityUserWithAccessibleElements> = this.user.asObservable();
}
